import {__usuarios_endpoints} from "@components/usuario/endpoints/__usuarios_endpoints.ts";
import {IRole} from "@models/roles/roles.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {_SegurancaEndpoints} from "@localization/siteMap/endpoints/_SegurancaEndpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export function useRolesOld() {
    const {Get} = useApi()
    const {getRolesPesquisa, GetRoles} = __usuarios_endpoints
    const {removeMembroRole} = _SegurancaEndpoints

    const getRole = async (id: number): Promise<IRole | undefined> => {
        return Get(GetRoles({ids: [id]}, {page: 1, pageSize: 1})).then(
            x => {
                return x.items[0]
            }
        )
    }
    const getRoles = async (filters: IGetRolesFilter | undefined, pagination: IPagination) => {
        return await Get(GetRoles(filters ?? {}, pagination));
    }

    const removeMembro = async (idRole: number, idUsuario: number) => {
        return await Get(removeMembroRole([{idRole, idUsuario}]))
    }


    return {getRole: getRole, getRolesPesquisa: getRolesPesquisa, getRoles: getRoles, removeMembro: removeMembro}
}